import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDLXNeUoI73sSW3hlFxtPdE82fZKBjp1Ew",
  authDomain: "yourbookmaybetoomuch.firebaseapp.com",
  projectId: "yourbookmaybetoomuch",
  storageBucket: "yourbookmaybetoomuch.firebasestorage.app",
  messagingSenderId: "160493857552",
  appId: "1:160493857552:web:f921628b36a43d15929395",
  measurementId: "G-RM3TY0WN1W"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Export analytics for use in the application
export { analytics };

export default app; 